import React from 'react'
import Link from 'gatsby-link'
import logo from '../assets/fia_logo.png'

const Header = ({ siteTitle }) => (
  <header className="navbar">
    <section className="navbar-section">
      <img style={{
        paddingLeft: "8px",
        paddingTop: "8px",
        width: "120px",
        height: "90px"}}
        src={logo}
        alt=""
      />
    </section>
    <section className="navbar-section">
      <a href='/' className="btn btn-link">Home</a>
      {/*<a href="/features" className="btn btn-link">Features</a>*/}
    </section>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js